import { render } from "./ShiftDashboardCalender.vue?vue&type=template&id=4852e20b&scoped=true"
import script from "./ShiftDashboardCalender.vue?vue&type=script&lang=js"
export * from "./ShiftDashboardCalender.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./ShiftDashboardCalender.vue?vue&type=style&index=1&id=4852e20b&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4852e20b"]])

export default __exports__